import { linkify } from '@/utils/text';
import Vue from 'vue';

Vue.filter('asLink', (text) => linkify(text));
